import styled from "styled-components";
import {
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	COLOR_WHITE,
	COLOR_TEXT_HIGHLIGHT,
	FONT_WT_REGULAR,
	COLOR_BLACK,
} from "@website-builder/utilities-index";

export const ResourcesWrapper = styled.div`
	padding: 50px 0px;
`;

export const ResourcesWrapperHandheld = styled.div`
	@media only screen and (min-width: ${DESKTOP_SM_BP + 1}px) {
		display: none;
	}
	color: ${COLOR_TEXT_PRIMARY_B2C};
	.stepsWrapper {
		display: block;
	}
	.step {
		width: 100%;
		display: flex;
		padding: 14px 0;
		flex-wrap: wrap;
		cursor: pointer;
		align-items: center;
		&:not(:last-child) .stepNumber,
		&:not(:first-child) .stepNumber {
			&:after,
			&:before {
				width: unset;
				height: unset;
				position: unset;
			}
		}
		border-bottom: 1px solid lightgray;
		&:nth-child(${(props) => props.activeStep + 1}) {
			.stepNumber {
				background: lightgrey;
			}
			.stepName {
				&:after {
					width: 0;
					content: unset;
					position: absolute;
					height: 0;
					border: unset;
				}
			}
		}
		.stepNumber {
			display: inline-flex;
			margin: 0;
		}
		.stepName {
			display: inline-block;
			margin-left: 30px;
			line-height: 1;
			max-width: unset;
			font-size: 18px;
			margin-top: 0;
			width: calc(100% - 70px);
			text-align: left;
			font-weight: ${FONT_WT_REGULAR};
		}
		.expandArrow {
			display: inline-block;
			cursor: pointer;
			span {
				transition: all 0.25s ease-in-out;
				display: inline-block;
				width: 12px;
				height: 12px;
				border-right: 1px solid ${COLOR_BLACK};
				border-bottom: 1px solid ${COLOR_BLACK};
				transform: rotateZ(45deg) translate(-25%, -25%);
			}
		}
		.stepDetail {
			display: block;
			width: 100%;
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			line-height: 1.5;
			overflow: hidden;
			height: 0;
			margin: 0;
			transition: all 0.1s ease-out;
			padding: 0 6px;
		}
	}
	${(props) =>
		props.expandedSteps.map(
			(index) => `
  .step:nth-child(${index + 1}) {
    .stepDetail {
      height: auto;
      margin-top: 20px;
    }
    .stepName {
      color: ${COLOR_TEXT_PRIMARY_B2C};
    }
    .stepNumber{
      background: ${COLOR_TEXT_HIGHLIGHT};
    }
    .expandArrow {
      span {
        transform: rotateZ(-135deg) translate(-25%, -25%);
      }
    }
  }`,
		)}
	.handheldHeading {
		text-align: center;
		font-size: 20px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
`;

export const Header = styled.div`
	font-size: 28px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	text-align: center;
	margin-bottom: 60px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin-bottom: 15px;
		font-size: 24px;
	}
`;

export const ResourcesContainer = styled.div`
	display: flex;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		display: none;
	}
`;

export const CardsContainer = styled.div`
	width: 80%;
`;

export const CardsWrapper = styled.div`
	display: flex;
	flex-flow: wrap;
	justify-content: start;
	a {
		text-decoration: none;
		text-align: center;
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		justify-content: center;
	}
`;

export const Container = styled.div`
	margin: 0 15px 60px;
	display: flex;
	flex-direction: column;
	width: 265px;
	align-items: center;
	border-radius: 3px;
	background-color: ${COLOR_WHITE};
	&:hover {
		transition: 0.3s;
		transform: translate(0, -5px);
	}
`;

export const Image = styled.div`
	img {
		height: 100%;
		width: 265px;
	}
`;

export const Title = styled.div`
	font-size: 18px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 21px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-top: 15px;
	text-align: left;
	padding: 0 10px;
`;

export const SubTitile = styled.div`
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	line-height: 24px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-top: 15px;
	text-align: left;
	padding: 0 10px;
`;

export const FilterOptions = styled.div`
	width: 20%;
	padding-left: 70px;
	.category {
		display: block;
		position: relative;
		margin-bottom: 15px;
		cursor: pointer;
		font-size: 18px;
		font-weight: ${FONT_WT_LIGHT};
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	.selectedCategory {
		display: block;
		position: relative;
		margin-bottom: 15px;
		cursor: pointer;
		font-size: 18px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
`;

export const Heading = styled.div`
	font-size: 22px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-bottom: 20px;
`;
